//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data(){
        return {
            grade:1
        }
    },
    created(){
        this.grade = Number(this.$route.query.grade);
    },
    methods: {
        jump(){
            if(this.grade < 3){
                this.$router.push({path:'/group'});
            }else{
                this.$router.push({path:'/user'});
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/withdrawComplete.vue